module.exports = __webpack_public_path__ + "assets/3506525476fe63156afe4aa617ac4cb8.svg";